import { render } from "./typing.vue?vue&type=template&id=4bd51e57"
import script from "./typing.vue?vue&type=script&lang=js"
export * from "./typing.vue?vue&type=script&lang=js"

import "./typing.vue?vue&type=style&index=0&id=4bd51e57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__